import request from '@/utils/request'
import qs from 'qs'

// ************************* 账号管理 ***************************
// 账号管理-列表
export const getAccountList = (data: any) =>
  request({
    url: '/enterpriseSign/account',
    method: 'get',
    params: data
  })

// 启用账号
export const setAccountUsed = (id: string) =>
  request({
    url: `/enterpriseSign/account/use/${id}`,
    method: 'put'
  })

// 标记账号为失效
export const setAccountInvalid = (id: string) =>
  request({
    url: `/enterpriseSign/account/invalid/${id}`,
    method: 'put'
  })

// 添加账号
export const addAccount = (data: any) =>
  request({
    url: '/enterpriseSign/account',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除账号
export const deleteAccount = (id: string) =>
  request({
    url: `/enterpriseSign/account/${id}`,
    method: 'delete'
  })

// 账号状态列表
export const getAccountStatus = () =>
  request({
    url: `/enterpriseSign/account/status`,
    method: 'get'
  })

// ************************* 签名信息 ***************************
// 签名信息-列表

export const getSignatureList = (data: any) =>
  request({
    url: '/enterpriseSign/pkg',
    method: 'get',
    timeout: 10 * 60 * 1000,
    params: data
  })

// 重签
export const reSign = (id: string) =>
  request({
    url: `/enterpriseSign/reSignPkg/${id}`,
    method: 'put'
  })

// 批量重签
export const batchReSign = (data: any) =>
  request({
    url: `/enterpriseSign/batchReSignPkg`,
    method: 'post',
    data: qs.stringify(data)
  })

// 签名信息状态列表
export const getSignatureStatus = () =>
  request({
    url: `/enterpriseSign/pkg/status`,
    method: 'get'
  })

// 签名信息分发地区列表
export const getSignatureServerCode = () =>
  request({
    url: `/enterpriseSign/pkg/ovhList`,
    method: 'get'
  })

// 签名信息分发状态列表
export const getSignatureTaskStatus = () =>
  request({
    url: `/enterpriseSign/pkg/ovhStatus`,
    method: 'get'
  })

// ************************* 签名应用管理 ***************************
// 应用列表
export const getAppList = (data: any) =>
  request({
    url: '/enterpriseSign/app',
    method: 'get',
    params: data
  })

// 添加应用
export const addApp = (data: any) =>
  request({
    url: '/enterpriseSign/app',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除应用
export const deleteApp = (id: string) =>
  request({
    url: `/enterpriseSign/app/${id}`,
    method: 'delete'
  })

// 修改应用排序
export const changeSeq = (data: any) =>
  request({
    url: '/enterpriseSign/app/changeSeq',
    method: 'post',
    data: qs.stringify(data)
  })

// 批量删除
export const batchDeleteApp = (data: any) =>
  request({
    url: '/enterpriseSign/batchDeleteApp',
    method: 'post',
    data: qs.stringify(data)
  })

export const getSwitchStatus = (params?: any) =>
  request({
    url: '/enterpriseSign/getFreeVersionSwitchStatus',
    method: 'get',
    params
  })

export const changeStatus = () =>
  request({
    url: '/enterpriseSign/changeFreeVersionSwitchStatus',
    method: 'post'
  })

// ************************* 免费应用管理 ***************************
// 获取免费APP列表
export const getFreeAppList = (params?: any) =>
  request({
    url: '/enterpriseSign/freeApp',
    method: 'get',
    params
  })

// 添加免费应用
export const addFreeApp = (data: any) =>
  request({
    url: '/enterpriseSign/freeApp',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除应用
export const deleteFreeApp = (id: string) =>
  request({
    url: `/enterpriseSign/freeApp/${id}`,
    method: 'delete'
  })

// 修改应用排序
export const changeFreeSeq = (data: any) =>
  request({
    url: '/enterpriseSign/freeApp/changeSeq',
    method: 'post',
    data: qs.stringify(data)
  })

// 批量删除
export const batchDeleteFreeApp = (data: any) =>
  request({
    url: '/enterpriseSign/batchDeleteFreeApp',
    method: 'post',
    data: qs.stringify(data)
  })
